var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCafr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#2B63D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 12 24 9 24 9C24 9 28 12 28 17C28 19.5 27.3 21.375 26.6 23.25C25.9 25.125 25.2 27 25.2 29.5H25.5C25.5 29.5 27.0802 19.0048 32 19.0048C33.829 19.0048 36 20.4729 36 23C36 25.5271 33.8391 27.7348 30.2 29.2043C33.0287 24.7115 29.1502 24.3714 27.5 29.5H29.5V31.5H26.5C26.5 31.5 27 33.799 30 35.799C27 35.799 25.5 34 25.5 34C25.5 34 26.5 37.5 24 40.5C21.5 37.5 22.5 34 22.5 34C22.5 34 21 35.799 18 35.799C21 33.799 21.5 31.5 21.5 31.5H18.5V29.5H20.5C18.8498 24.3714 14.9713 24.7115 17.8 29.2043C14.1609 27.7348 12 25.5271 12 23C12 20.4729 14.171 19.0048 16 19.0048C20.9198 19.0048 22.5 29.5 22.5 29.5H22.8C22.8 27 22.1 25.125 21.4 23.25C20.7 21.375 20 19.5 20 17Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgCafr;